<template xmlns="http://www.w3.org/1999/html">
    <div class="modal-info-exam " v-if="infoExamRes && infoExamRes.length">
        <div class="d-flex align-items-center justify-content-between exam-name">
            <p>
                {{ infoExamRes[0].name }}
            </p>
            <div class="total-of-question">
                {{ $t('exam.label.total_question') }}: {{ infoExamRes[0].question_id.length }}
            </div>
            <div class="d-flex align-items-center" style="width: 250px">
                <b-input-group class="ml-2" align-v="center">
                    <div class="d-flex set-time">
                        <b-input-group-prepend class="time-count__icon">
                            <img src="https://img.icons8.com/office/25/000000/alarm-clock--v1.png"/>
                        </b-input-group-prepend>
                        <b-input v-model="this.infoExamRes[0].time" plaintext></b-input>
                    </div>
                    <p class="pl-1 align-self-center">min</p>
                </b-input-group>
                <div>
                    {{ updateTime }}
                </div>
            </div>
        </div>
        <br/>
        <div class="tableQues">
            <table class="table table-bordered w-150 ">
                <tbody
                        v-for="(fData, index) in dataConverted"
                        v-bind:key="fData.id"
                >
                <tr>
                    <td style="width: 65% !important" v-if="!fData.child">
                        <div
                            class="pl-2 mb-3 w-100 title-question"
                            disabled :rows="3"
                        >
                            {{$t('exam.label.question')}} {{ index + 1 }}. <span v-html="fData.title"> </span> ({{$t("exam.label.score")}}: {{ fData.score }})
                            <!-- button edit -->
                            <b-icon
                                icon="pencil"
                                @click="showEditQuestion(fData.id, fData.topic_name)"
                                class="edit"
                                style="color: #F29D38"
                            ></b-icon>
                        </div>
                        <div>
                            <audio
                                    v-if="fData.audio_s3"
                                    :src="fData.audio_s3"
                                    controls
                                    class="mb-2"
                            ></audio>
                        </div>
                        <div class="image-question">
                            <b-img
                                    v-if="fData.image_s3"
                                    :src="fData.image_s3"
                                    class="mb-3"
                            >
                            </b-img>
                            <b-img
                                    v-if="fData.embed_image_video && !fData.embed_image_video.includes(`/embed/`)"
                                    :src="fData.embed_image_video"
                                    class="mb-3"
                            >
                            </b-img>
                            <iframe width="620" height="380"
                                    :src="fData.embed_image_video"
                                    v-if="fData.embed_image_video && fData.embed_image_video.includes(`/embed/`)"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                            <video
                                    v-if="fData.video_s3"
                                    class="mb-3"
                                    controls
                            >
                                <source :src="fData.video_s3" type="audio/mp4">
                            </video>
                            <div v-html="fData.embed_audio" v-if="fData.embed_audio"></div>
                        </div>
                        <b-row v-if="fData.type!==`Writing`" class="answer-row">
                            <b-col cols="6" class="p-0 mb-1 d-flex" v-for="(ansData,index) in fData.answer"
                                   v-bind:key="index">
                                <div disabled class="answerIndex ml-3 mr-2" :class="ansData.isCorrect === true ? 'true' : 'false'">{{ index + 1 }}</div>
                                <b-img v-if="ansData.image_answer_s3"
                                       v-bind:src="ansData.image_answer_s3"
                                       class="ml-1"></b-img>
                                <p v-else class="ml-1 answer-value" v-html="ansData.ans_value"></p>
                            </b-col>
                        </b-row>
                    </td>

                    <td style="width: 65% !important" v-if="fData.child">
                        <div class="group_question_title">{{ $t(`exam.label.group_question`) }} {{ index + 1 }}.
                            {{ fData.topic_name }} ({{ $t("exam.label.total_question") }}: {{ fData.child.length }},
                            {{ $t("exam.label.total_score") }}: {{ countScoreGroupQuestion(fData.child) }})
                        </div>
                        <div v-for="(row, int) in fData.child" class="my-2 mx-5">
                            <div class="pl-2 mb-3 mt-2 w-100 title-question-group" disabled :rows="3">
                            {{$t('exam.label.question')}} {{int + 1}}. <span v-html="row.title" ></span> ({{$t("exam.label.score")}}: {{ row.score }})
                             <!-- button edit -->
                               <b-icon
                                    icon="pencil"
                                    @click="showEditQuestion(row.id, row.topic_name)"
                                    class="edit"
                                    style="color: #F29D38"
                                ></b-icon>
                            </div>
                            <div>
                                <audio
                                        v-if="row.audio_s3"
                                        :src="row.audio_s3"
                                        controls
                                        class="mb-2"
                                ></audio>
                            </div>
                            <div class="image-question">
                                <b-img
                                        v-if="row.image_s3"
                                        :src="row.image_s3"
                                        class="mb-3"
                                >
                                </b-img>
                                <b-img
                                        v-if="row.embed_image_video && !row.embed_image_video.includes(`/embed/`)"
                                        :src="row.embed_image_video"
                                        class="mb-3"
                                >
                                </b-img>
                                <iframe width="620" height="380"
                                        :src="row.embed_image_video"
                                        v-if="row.embed_image_video && row.embed_image_video.includes(`/embed/`)"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <video
                                        v-if="row.video_s3"
                                        class="mb-3"
                                        controls
                                >
                                    <source :src="row.video_s3" type="audio/mp4">
                                </video>
                                <div v-html="row.embed_audio" v-if="row.embed_audio"></div>
                            </div>
                            <b-row v-if="row.type!==`Writing`" class="answer-row">
                                <b-col cols="6" class="p-0 mb-1 d-flex" v-for="(ansData,index) in row.answer"
                                       v-bind:key="index">
                                    <div disabled class="answerIndex ml-3 mr-2" :class="ansData.isCorrect === true ? 'true' : 'false'">{{ index + 1 }}</div>
                                    <b-img v-if="ansData.image_answer_s3"
                                           v-bind:src="ansData.image_answer_s3"
                                           class="ml-1"></b-img>
                                    <p v-else class="ml-1 answer-value"><span v-html="ansData.ans_value"></span></p>
                                </b-col>
                            </b-row>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br/>
        <div class="d-flex justify-content-end">
            <b-button class="btn-close" @click="hideModal">{{ $t("exam.label.close") }}</b-button>
        </div>
        <b-modal id="modal-edit" hide-header hide-footer size="xl">
            <question-edit
                :titleTopic="titleTopic"
                :callback="reloadExam"
                :page="1"
            ></question-edit>
        </b-modal>
        
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment       from "moment";
import QuestionEdit from "../QuestionList/QuestionEditModal.vue";

export default {
    components: {QuestionEdit},
    computed: {
        ...mapGetters({
            infoExamRes: "exam/adminExamInfoRes"
        })
    },
    props: ["idExam"],
    data() {
        return {
            listQuestions: [],
            updateTime: '',
            dataConverted: [],
            titleTopic: ""
        };
    },
    created() {
        this.getInfoExam();
    },
    methods: {
        hideModal() {
            this.$emit("close-modal-info");
        },
        async reloadExam() {
            await this.getInfoExam();
        },
        async getInfoExam() {
            await this.$store.dispatch("exam/getInfoAdminExam", this.$props.idExam);
            this.listQuestions = this.infoExamRes[0].question;
            this.updateTime = moment(this.infoExamRes[0].updated_at).format("DD/MM/YYYY");
            this.convertData();
        },
        convertData() {
            // const list = this.listQuestions;
            this.dataConverted = [];

            const list = [...this.listQuestions];
            for (let i = 0; i < list.length; i++) {
                if (!list[i].id_topic) {
                    this.dataConverted.push(list[i]);
                } else {
                    let tmp = [];
                    tmp.push(list[i]);
                    let j = i + 1;
                    while (j < list.length) {
                        if (list[i].id_topic === list[j].id_topic) {
                            tmp.push(list[j]);
                            list.splice(j, 1);
                        } else {
                            j++;
                        }
                    }
                    this.dataConverted.push({
                        id_topic: list[i].id_topic,
                        child: tmp,
                        topic_name: list[i].topic_name
                    });
                }
            }
            // this.dataConverted = list
        },
        countScoreGroupQuestion(group) {
            let totalScore = 0;
            group.forEach(question => {
                totalScore += question.score;
            });
            return totalScore;
        },
        async showEditQuestion(item, topic) {
            this.loading = true;

            // Không render QuestionEdit cũ
            this.showQuestionEdit = false;

            await this.$store.dispatch("config/getCategory");
            await this.$store.dispatch("question/showEditQuestion", item);

            this.titleTopic = topic;

            await this.$store.dispatch("question/deleteExplain");

            // Mở modal trước
            this.$bvModal.show("modal-edit");

            this.loading = false;
        }
    }
};
</script>

<style>
.modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0rem 1rem;
    border-bottom: 1px solid #ffffff;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}

#modal-info-exam___BV_modal_content_ {
    margin-top: 40px;
    border-radius: 20px;
}

.exam-name p {
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    color: #6674BB;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 35%;
    line-height: 1.8rem;
    height: 1.8rem;
    overflow: hidden;
}

.total-of-question {
    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
    margin-right: 10%;
    width: 190px;
}

.set-time {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    width: 90px;
}

.set-time img {
    padding: 10px 10px;
}

.time-count__icon {
    background-color: white;
    border: none;
}

.tableQues {
    padding: 30px;
    overflow: auto;
    height: 65vh;
}

.tableQues audio {
    height: 20px;
    width: 300px;
}

.answerIndex {
    border-radius: 50%;
    border: solid 2px rgba(0, 0, 0, 0.99);
    background-color: white !important;
    color: black !important;
    font-size: 12px;
    padding: 0px 6px;
    font-weight: bold;
    height: 23px;
}

.answerIndex.true {
    border-color: green;
    background: green !important;
    color: white !important;
}



.btn-close {
    width: 120px;
    background: #3182CE;
    border: 1px solid #EEEEEE;
    border-radius: 4px !important;
    font-size: 14px;
    height: 35px;
}

.btn-close:hover {
    background-color: #3182CE !important;
    border: none !important;
    color: white !important;
    height: 35px;
}

.answer-value {
    /*line-height: 1.8rem;*/
    /*overflow: hidden;*/
    width: 80%;
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
}

.image-question img {
    width: 400px !important;
    height: 300px !important;
    object-fit: contain;
}

.image-question video {
    width: 400px !important;
    height: 300px !important;
}

.title-question {
    min-height: 100px;
    background-color: white;
    border: 1px solid #C4C4C4;
    overflow: scroll;
    resize: vertical;
    position: relative;
     overflow: auto;
}

.title-question-group {
    resize: vertical;
    overflow: auto;
    min-height: 100px;
    background-color: white;
    border: 1px solid #C4C4C4 !important;
    position: relative;
}
svg.bi-pencil.edit {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    width: 20px;
    height: 20px;
}

.answer-row img {
    width: 170px;
    height: 110px;
    object-fit: contain;
}

.group_question_title {
    font-weight: 700;
    font-size: 17px;
    color: #6674BB;
}

</style>
